import { defineStore } from 'pinia'
import { computed, ref } from "vue";
import { storage } from "@utils/storage";
import { deepCopy } from "@utils/utils";

export const useLocationStore = defineStore('location', () => {
    const locationCity = ref(null);

    const location = ref(null);

    const setLocationCity = (data) => {
        locationCity.value = data;
    }

    const setLocation = (data) => {
        location.value = data;
        storage.set('location', deepCopy(data));
    }

    const checkedCity = ref(storage.get("checkedCity") || null);

    const setCheckedCity = (data) => {
        checkedCity.value = data;
        storage.set('checkedCity', deepCopy(data));
    }

    const currCity = computed(() => {
        return checkedCity.value || locationCity.value
    })

    return {
        location,
        setLocation,
        currCity,
        locationCity,
        setLocationCity,
        checkedCity,
        setCheckedCity
    }
})
